<script setup lang="ts">
const baseUrl = useRuntimeConfig().public.base.url;

useHead({
    meta: [
        { content: `${baseUrl}/karriere-share-image-v3.png`, property: 'og:image' }
    ],
    titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | karriere.at` : 'karriere.at';
    }
});

useGtm();
onMounted(() => {
    if (window?.dataLayer) {
        window?.dataLayer?.push({ content_group_detail: 'E-Commerce' });
    }
});
</script>

<template>
    <div class="flex min-h-screen flex-col text-gray-900">
        <NuxtLoadingIndicator color="#142542" :height="2" class="shadow-lg" />
        <header>
            <TheNavigationBar />
        </header>
        <main class="grow pt-nav-mobile">
            <slot />
        </main>
        <TheFooter />
    </div>
</template>
